import { Col, Input, InputGroup } from "reactstrap";
import { FollowUsData, PopularTagsData } from "../../../../Data/Blog/Blog";
import { FollowUs, Href, PopularTags, SearchTitle } from "../../../../Constants/Constants";

const Search = () => {
  return (
    <Col xl="12" lg="4" sm="6">
      <h4>{SearchTitle}</h4>
      <div className="blog-search">
        <InputGroup>
          <Input type="text" placeholder="search in blog" />
          <span><i className="fa fa-search" /></span>
        </InputGroup>
      </div>
      <h4>{FollowUs}</h4>
      <ul className="blog-follow">
        {FollowUsData.map((item, index) => (
          <li key={index}>
            <a href={item.url}><i className={`fa fa-${item.icon}`} /></a>
          </li>
        ))}
      </ul>
      <h4>{PopularTags}</h4>
      <ul className="tags">
        {PopularTagsData.map((item, index) => (
          <li key={index}><a href={Href}>{item}</a></li>
        ))}
      </ul>
    </Col>
  );
};

export default Search;
